 
export type FeatureFlags = typeof featureFlags;

export const featureFlags = {
    "Entry Form": true,
    "Remote Control": true,
    "Series Groups": true,
    "Event Cards": true,
    "Siren": true,
    "Recently Viewed": true,
} satisfies Record<string, boolean | string[]>;
